// --------------------------------------------------------
// GENERAL IMPORTS
// --------------------------------------------------------
import AuthDTO from "../../../models/auth/AuthDTO";
import { GenericService } from "./Generic.service";

// --------------------------------------------------------
// CLASS CONNECTION
// --------------------------------------------------------
export class Auth extends GenericService<AuthDTO> {
  // --------------------------------------------------------
  // ATTRIBUTES
  // --------------------------------------------------------
  readonly URI: string = "Auth";
  // --------------------------------------------------------
  // CONSTRUCTOR
  // --------------------------------------------------------
  constructor() {
    super();
    this.setUri(this.URI);
  }
  // --------------------------------------------------------
  // METHODS
  // --------------------------------------------------------

  public async postAuth(data: AuthDTO) {
    return await super.post(data);
  }

  public async postRefreshTokenAuth(body: any) {
    return await super.post(body);
  }

  public async forgotPassword(body: any){
      return await super.postByResource(body, 'ForgotPassword')
  }

  public async resetPassword(body: any){
      return await super.postByResource(body, 'ResetPassword')
  }

  public async postAuthUsuario(body: any) {
      return await super.postByResource(body, 'LoginUsuario')
  }
  
  public async postEnvioEmail(body: any){
    return await super.postByResource(body, `ConfirmEmail`)
  }
  
  public async RedefinePassword(body: any){
    return await super.postByResource(body, 'RedefinePassword')
  }

}
